export default {
    header: {
        heading: 'Feedback cycle information',
        description: 'Name your cycle and define its reference period.',
    },
    name: {
        label: 'Cycle name',
        placeholder: 'e.g., Annual evaluation 2026',
    },
    period: {
        label: 'Reference period',
        startPlaceholder: 'Start date',
        endPlaceholder: 'End date',
        hint: "Reference periods define the time range covered by evaluation on an employee's performance, typically used for annual, mid-year or quarterly evaluation.",
    },
    audience: {
        label: 'Audience',
        entireCompany: {
            label: 'Entire company',
            description: 'Include every employee in the organization.',
        },
        specificTeams: {
            label: 'Specific teams',
            description: 'Target employees based on selected attributes.',
        },
        noAttributeConfigured:
            'No demographic attribute is configured on your account. Add them in your company settings to target specific teams.',
        filterAnd: 'AND',
        chooseAttribute: 'Choose an attribute',
        chooseValues: 'Choose values',
        selectAttributeFirst: 'Choose an attribute first.',
        removeFilter: 'Remove the filter',
        addAttribute: 'Add a criterion',
    },
    validation: {
        nameRequired: 'The cycle name is required',
        nameTooLong: 'The cycle name is too long',
        nameAlreadyUsed: 'This cycle name is already used.',
        periodRequired: 'The reference period is required',
        periodEndBeforeStart: 'The end date must be on or after the start date',
        noAudience: 'The audience must include at least one employee',
    },
};
